export default __webpack_public_path__ + "static/media/reglogin-m-bg-cn.d5ba8fb2.webp";